/**
 * Which of a customer's group memberships belong to a given organization, as
 * display names. Pure — the Firestore reads live in customer-groups.ts.
 *
 * Subgroups are listed before parent groups so the most specific membership
 * reads first; within a tier, alphabetical.
 */
export interface GroupLike {
  name?: string;
  organization?: string;
  groupType?: 'parent' | 'subgroup';
}

export function orgGroupNames(groups: GroupLike[], organizationId: string): string[] {
  const mine = groups.filter((g) => g.organization && g.organization === organizationId);
  const tier = (g: GroupLike) => (g.groupType === 'parent' ? 1 : 0);
  const names = mine
    .slice()
    .sort((a, b) => tier(a) - tier(b) || String(a.name || '').localeCompare(String(b.name || '')))
    .map((g) => String(g.name || '').trim())
    .filter(Boolean);
  return Array.from(new Set(names));
}
